import SalesLeadTable from "./view/SalesLeadTable";
import { PERMISSIONS } from "../../../PermissionsConstants";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { useRecoilValue } from "recoil";
const SalesLead = () => {
  const viewPermission =
    PERMISSIONS.permission_utilities_configureagreement_saleslead_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  return (
    <>{userPermissions.includes(viewPermission) ? <SalesLeadTable /> : ""}</>
  );
};

export default SalesLead;
